import { HttpModelConverter } from "src/app/modules/core/converter/httpModel.converter";
import { Injectable } from "@angular/core";
import { PrescriptionDefinitionLineSummaryModel } from "../prescriptionDefinitionLineSummary.model";
import {PermissionsConverter} from "../../../../../../common/converter/permissions.converter";
import {PrescriptionMedicineConverter} from "../../../../medicine/api/model/converter/prescriptionMedicine.converter";
import {PrescriptionMedicineSummaryModel} from "../../../../medicine/api/model/prescriptionMedicineSummary.model";
import {
    PrescriptionMedicineSummaryConverter
} from "../../../../medicine/api/model/converter/prescriptionMedicineSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class PrescriptionDefinitionLineSummaryConverter extends HttpModelConverter<PrescriptionDefinitionLineSummaryModel> {

    constructor(private permissionConverter: PermissionsConverter,
                private medicineConverter: PrescriptionMedicineSummaryConverter) {
        super();
    }

    protected createInstance(): PrescriptionDefinitionLineSummaryModel {
        return new PrescriptionDefinitionLineSummaryModel();
    }

    protected enrichObject(result: PrescriptionDefinitionLineSummaryModel, src: PrescriptionDefinitionLineSummaryModel) {
        result.permissions = this.permissionConverter.convert(src.permissions);
        result.medicine = this.medicineConverter.convert(src.medicine);
    }
}